module.exports = __webpack_public_path__ + "bg-13.fccd64c9b98edbd81d54.jpg";


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/assets/img/bg-13.jpg
// module id = ../../../../../src/assets/img/bg-13.jpg
// module chunks = 39